import { createFileRoute } from "@tanstack/react-router";

import { FilesPage } from "@/pages/Admin";

export const Route = createFileRoute("/app/admin/files")({
  component: FilesPage,
});
